import { FaSave, FaSpinner, FaTrash } from 'react-icons/fa';
import { ConfirmModal } from 'reactstrap-alert';
import { YoApiItemComponent } from '@yooink/yorestapi/frontend/es/YoApiComponent';
import Checkbox from '@yooink/youi/es/Checkbox';
import Input from 'reactstrap/es/Input';
import Button from 'reactstrap/es/Button';
import Api from './Api';

class ItemRow extends YoApiItemComponent {
	getApi = () => Api;

	getItemId = () => this.state.item._id;

	fetch = () => this.setState({ item: this.props.item, loaded: true });

	componentWillReceiveProps (nextProps, nextContext) {
		if (nextProps.item._id !== this.props.item._id) {
			this.setState({ item: nextProps.item });
		}
	}

	remove = async () => {
		const result = await ConfirmModal('Вы действительно хотите удалить?');
		if (result) {
			try {
				await this.setState({
					disabled: true
				});
				await this.getApi().remove(this.getItemId());
				this.props.fetch();
			} catch (e) {
				await this.setState({
					disabled: false
				});
			}
		}
	};

	render () {
		const { editData, disabled, item, loaded } = this.state;
		if (!loaded) return null;

		return (
			<tr>
				<th style={{ fontWeight: 500 }} scope="row">{item._id.substr(-5)}</th>
				<td>
					<Input
						disabled={disabled}
						key={`${item._id}_key`}
						defaultValue={item.key}
						onBlur={(e) => this.setField('key', e.target.value)}
					/>
				</td>
				<td>
					<Input
						disabled={disabled}
						key={`${item._id}_ru`}
						defaultValue={item.value?.ru}
						onBlur={(e) => this.setField('value.ru', e.target.value)}
					/>
				</td>
				<td>
					<Input
						disabled={disabled}
						key={`${item._id}_en`}
						defaultValue={item.value?.en}
						onBlur={(e) => this.setField('value.en', e.target.value)}
					/>
				</td>
				<td>
					<Input
						disabled={disabled}
						key={`${item._id}_cs`}
						defaultValue={item.value?.cs}
						onBlur={(e) => this.setField('value.cs', e.target.value)}
					/>
				</td>
				<td>
					<Checkbox
						disabled={disabled}
						key={`${item._id}_export`}
						checked={item.export}
						onChange={(e) => this.setField('export', e.target.checked)}
					/>
				</td>
				<td>
					<Button color="danger" onClick={() => this.remove()}>
						{disabled ? (
							<FaSpinner />
						) : (
							<FaTrash />
						)}
					</Button>
					<Button color="primary" disabled={disabled || (Object.keys(editData).length === 0)} onClick={this.save}>
						{disabled ? (
							<FaSpinner />
						) : (
							<FaSave />
						)}
					</Button>
				</td>
			</tr>
		);
	}
}

ItemRow.propTypes = {};

export default ItemRow;
